// extracted by mini-css-extract-plugin
export default {"modalFooter":"cRpwFAjEE3_pdp","onScroll":"e2GtgtWXpX_pdp","full-screen":"hph5c1Lhxc_pdp","column":"NPPhetmFRn_pdp"};